import { QueryClient, VueQueryPlugin } from "@tanstack/vue-query";
import { createPinia } from "pinia";
import { Notify, Quasar } from "quasar";
import { createApp } from "vue";

import App from "./App.vue";
import { applyScheme, readStoredScheme } from "./composables/useColorScheme";
import { router } from "./router";

import "@quasar/extras/roboto-font/roboto-font.css";
import "@quasar/extras/material-icons/material-icons.css";
import "quasar/src/css/index.sass";
import "./assets/app.sass";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false },
  },
});

const app = createApp(App);
app.use(createPinia());
app.use(router);
app.use(VueQueryPlugin, { queryClient });
app.use(Quasar, { plugins: { Notify } });

// Must run after Quasar is installed — the Dark plugin needs its $q. The
// inline script in index.html has already painted the right colour; this
// hands ownership of the class back to Quasar.
applyScheme(readStoredScheme());

app.mount("#app");
